<template>
  <div class="layer1 flex-col">
    <div class="outer1 flex-row">
      <img class="img1" referrerpolicy="no-referrer" src="/icon/reg/r1.png" />
      <div class="section1 flex-col">
        <span class="txt1">
          {{ `欢迎入驻课后服务开放平台，请先选择注册的类型。` }}
        </span>
        <span class="txt2">请谨慎选择，一旦提交将无法修改。</span>
      </div>
    </div>
    <div class="outer2 flex-col"></div>
    <div class="main">
      <div class="right" @click="option(2)">
        <div class="outer3 flex-row">

          <div class="outer4 flex-col">
            <span class="word4">个人课程方</span>
            <div class="box1 flex-col">
              <div class="mod1 flex-col"></div>
            </div>
          </div>
          <div class="outer6">
            <div class="word6">未受聘于学校和社会企业，注册后个人为学校提供课后服务的课程和授课</div>
            <div class="word7">您需要提前准备以下资料:</div>
            <div class="word8">
              身份证、学历证书、资格&nbsp;证书、专业证书/获奖证书、健康证、无犯罪记录证明等
            </div>
          </div>
          <div class="pic-parent">
        <img
            class="pic2"
            referrerpolicy="no-referrer"
            :src="this.selected === 2 ? this.checked : this.unchecked"
          />
        </div>
        </div>
      </div>
      <div class="right" @click="option(1)">
        <div class="outer3 flex-row">

          <div class="outer4 flex-col">
            <span class="word4">社会企业</span>
            <div class="box2 flex-col">
              <div class="block2 flex-col"></div>
            </div>
          </div>
          <div class="outer6">
            <div class="word6">针对于注册企业或组织，可提供多种课程内容和多个授课老师</div>
            <div class="word7">您需要提前准备以下资料:</div>
            <div class="word8">营业执照、负责人身份证、办学许可证等</div>
          </div>
        </div>
        <div class="pic-parent">
          <img
            class="pic2"
            referrerpolicy="no-referrer"
            :src="this.selected === 1 ? this.checked : this.unchecked"
          />
        </div>
      </div>
      <div class="right" @click="option(3)">
        <div class="outer3 flex-row">

          <div class="outer4 flex-col">
            <span class="word4">高校与协会</span>
            <div class="box3 flex-col">
              <div class="block2 flex-col"></div>
            </div>
          </div>
          <div class="outer6">
            <div class="word6">针对国家认可的高等院校和行业协会</div>
            <div class="word7">
              高校与协会入驻属于邀请制，必须由符合条件的高校与协会使用邀请码才可注册入驻
            </div>
          </div>
        </div>
        <div class="pic-parent">
          <img
            class="pic2"
            referrerpolicy="no-referrer"
            :src="this.selected === 3 ? this.checked : this.unchecked"
          />
        </div>
      </div>
    </div>
    <div class="outer9 flex-col"></div>
    <div class="prompt" v-if="!bureauDataId">当前域名不存在，请检查网址是否输入正确</div>
    <a-button type="primary" class="outer10" @click="next(1)" :disabled="bureauDataId <= 0" > 下一步 </a-button>
    <span class="word10" @click="next(5)">已申请，查看申请记录</span>
  </div>
</template>
<script>
import Vue from 'vue'
import bureau from '../../../api/bureau'
export default {
  name: 'RegistrationStepOne',
  data() {
    return {
      bureauData: null, //站点
      checked: '/icon/reg/cY.png',
      unchecked: '/icon/reg/cN.png',
      selected: 1,
      bureauDataId: null, // 判断id是否存在
    }
  },
  mounted(){

  },
  created() {
    console.log(this.bureauData,this.bureauDataId,'this.bureauData111')
    this.$store.commit('register/changeAgreement', false)
    this.selected = this.$store.state.register.form.institutionType
    this.initObtain()
  },
  methods: {
   async initObtain(){
    this.bureauData = null;
      try {
     const res = await bureau.getBureau()
   if(res.id){
   this.bureauDataId = res.id
   }
   console.log(res,this.bureauData,this.bureauDataId,'then报错的信息是什么')
    
   } catch (err) {
   console.log(err,'catch错误的信息是什么')
   }
   console.log(this.bureauDataId,'这里面的值是什么1')
   if(!this.bureauDataId){
      console.log(this.bureauDataId,'这里面的值是什么2')
      this.$router.push('/portal')
    }
    },
    mobileRules(rule, value, callback) {
      if (!value) {
        callback('请输入常用的手机号')
      } else if (!/^[\u0030-\u0039]{11}$/.test(value)) {
        callback('请输入正确的手机号')
      }
      callback()
    },
    next(step) {
      this.$emit('nextStep', step)
      this.$store.commit('register/changePersonage', this.selected)
    },
    option(id) {
      this.selected = id
    },
  },
}
</script>

<style lang="scss" scoped>
.layer1 {
  z-index: auto;
  width: 100%;
  height: 100%;
  padding: 6px;
  flex: 5;
  position: relative;
}

.prompt{
  color: red;
  text-align: center;
}

.right {
  flex: 1;
  width: 100%;
  margin: 40px 0 0 0;
}

.outer1 {
  z-index: auto;
  width: 441px;
  height: 50px;
  margin-left: 30px;
  justify-content: space-between;
  //   display: inline-block;
}

.img1 {
  z-index: 43;
  width: 50px;
  height: 50px;
}

.section1 {
  z-index: auto;
  width: 368px;
  height: 50px;
  display: inline-block;
  //   padding-top: 10px;
  vertical-align: middle;
  padding-left: 23px;
}

.txt1 {
  z-index: 11;
  width: 368px;
  height: 22px;
  overflow-wrap: break-word;
  color: rgba(0, 0, 0, 0.85);
  font-size: 16px;
  font-family: PingFangSC-Semibold;
  white-space: nowrap;
  line-height: 22px;
  text-align: left;
}

.txt2 {
  z-index: 12;
  width: 224px;
  height: 20px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(135, 136, 138, 1);
  font-size: 14px;
  font-family: PingFangSC-Regular;
  white-space: nowrap;
  line-height: 20px;
  text-align: left;
  align-self: flex-start;
  margin-top: 8px;
}

.outer2 {
  z-index: 39;
  width: 100%;
  height: 4px;
  background-color: rgba(235, 241, 253, 1);
  align-self: center;
  margin-top: 37px;
}
.main {
  display: flex;
  justify-content: space-evenly;
  flex-wrap: wrap;
}
.outer3 {
  z-index: auto;
  width: 100%;
  position: relative;
  justify-content: center;
  align-items: center;
}

.outer4 {
  height: 180px;
  border-radius: 4px;
  overflow: hidden;
  background: url('../../../../public/institution.png') 100% no-repeat;
  margin-left: auto;
  margin-right: auto;
  width: 300px;
  justify-content: center;
  position: relative;
}


.pic-parent{
  width: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
}
.word4 {
  z-index: 40;
  width: 180px;
  height: 56px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 0.85);
  font-size: 40px;
  font-family: PingFangSC-Semibold;
  white-space: nowrap;
  line-height: 56px;
  text-align: center;
  // text-shadow: 0px 2px 10px rgba(0, 0, 0, 0.5);
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.box1 {
  z-index: 22;
  height: 180px;
  background: url('../../../../public/person.png') 100% no-repeat;
  width: 300px;
  position: absolute;
  left: 0;
  top: 0;
}

.mod1 {
  z-index: 23;
  width: 300px;
  height: 180px;
  // background-color: rgba(0, 0, 0, 0.5);
}

.img2 {
  z-index: 33;
  width: 50px;
  height: 50px;
  margin-left: 60px;
  position: absolute;
  top: 10px;
}

.outer5 {
  z-index: 25;
  height: 180px;
  border-radius: 4px;
  overflow: hidden;
  background: url(/icon/reg/bg.png) 100% no-repeat;
  margin-left: 24px;
  width: 300px;
  justify-content: center;
  align-items: center;
  position: relative;
  display: inline-block;
}

.word5 {
  z-index: 41;
  width: 180px;
  height: 56px;
  //   display: block;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 0.85);
  font-size: 40px;
  font-family: PingFangSC-Semibold;
  white-space: nowrap;
  line-height: 56px;
  text-align: left;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.box2 {
  height: 180px;
  background: url('../../../../public/institution.png') 100% no-repeat;
  width: 300px;
  position: absolute;
  left: 0;
  top: 0;
}
.box3 {
  height: 180px;
  background: url('../../../../public/universities.png') 100% no-repeat;
  width: 300px;
  position: absolute;
  left: 0;
  top: 0;
}

.block2 {
  z-index: 27;
  width: 300px;
  height: 180px;
  // background-color: rgba(0, 0, 0, 0.49);
}

.outer6 {
  margin-left: auto;
  margin-right: auto;
  width: 300px;
  margin-top: 20px;
  height: 100px;
}

.word6 {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #1b1d26;
  line-height: 22px;
}
.word7 {
  margin-top: 10px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(114, 115, 118, 0.85);
  line-height: 22px;
}

.word8 {
  margin-top: 6px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(114, 115, 118, 0.85);
  line-height: 22px;
}
.outer9 {
  width: 100%;
  height: 1px;
  background-color: #f8f8f8;
  margin-top: 50px;
}

.outer10 {
  z-index: 8;
  height: 42px;
  margin-top: 23px;
  width: 140px;
  left: 50%;
  transform: translate(-50%);
}
.word10 {
  z-index: 38;
  width: 140px;
  height: 50px;
  display: block;
  overflow-wrap: break-word;
  color: rgba(78, 148, 255, 1);
  font-size: 14px;
  text-decoration: underline;
  font-family: PingFangSC-Regular;
  line-height: 20px;
  margin-top: 45px;
  margin-bottom: 45px;
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
}

@media screen and (max-width: 1500px) {
  .outer4 {
    width: 253px;
  }
  .outer6 {
    width: 253px;
  }
  .pic-parent{
    width: 253px;
  }
  .pic2 {
    left: 50%;
  }
}
</style>
